/* lcl-buybox-v2.js (20 Sep 2026)
   Keeps the add-to-basket subline, the "saving applied" line and the card selected-state
   in sync with the chosen cycle option. Selection styling itself is CSS (:checked); this
   only mirrors it and updates the two text elements. No dependency on theme JS.
   Spec: Dropbox twoplus ads/product-pages/pdp-buybox-v2/README.md */
(function () {
  'use strict';

  function selectedOpt() {
    var input = document.querySelector('.lcl-bb2__input:checked');
    return input ? input.closest('[data-bb2-opt]') : null;
  }

  function update() {
    var opt = selectedOpt();
    if (!opt) return;

    var n = opt.getAttribute('data-cycles') || '';
    var ins = opt.getAttribute('data-ins') || '';
    var price = opt.getAttribute('data-price') || '';
    var hasSave = opt.getAttribute('data-has-save') === 'true';

    var sub = document.querySelector('[data-bb2-cta-sub]');
    if (sub) sub.textContent = price + ' · ' + n + (n === '1' ? ' cycle' : ' cycles') + ' · ' + ins + ' inseminations';

    var applied = document.querySelector('[data-bb2-applied]');
    if (applied) applied.hidden = !hasSave;

    var all = document.querySelectorAll('[data-bb2-opt]');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-selected', all[i] === opt);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('lcl-bb2__input')) update();
  });

  // the theme's product form fires this after it resolves the variant (covers programmatic changes)
  document.addEventListener('theme:variant:change', function () { setTimeout(update, 0); });

  // reviews link: scroll to the Judge.me widget wherever it sits on the page
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-bb2-reviews-link]') : null;
    if (!a) return;
    var target = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-rev-widg');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // keep the theme's own "Add to cart" string in step with the button text set in the section settings,
  // so the label does not flip back after an add-to-cart
  function syncCtaString() {
    try {
      if (window.bb2CtaText && window.theme && window.theme.strings) window.theme.strings.add_to_cart = window.bb2CtaText;
    } catch (err) {}
  }
  syncCtaString();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncCtaString(); setTimeout(update, 50); });
  } else {
    setTimeout(update, 50);
  }
})();
